<template lang="pug">
v-container(pa-0 ma-0)
  v-row(no-gutters)
    v-col(class="tw-border tw-border-gray-lighten-2 image-gallery-container")
      div(class="tw-z-0 tw-relative")
        v-carousel(hide-delimiters height="320")
          v-carousel-item(
            v-if="images.length != 0"
            v-for="(image, images) in images"
            :key="image.id"
            :src="path(image.path)"
            height="320"
            width="100%"
          )

          v-carousel-item(
            v-if="images.length == 0"
            width="100%"
            height="320"
            :src="require('@/assets/images/placeholder-image.jpg')"
          )
        div(
          v-if="images.length == 0"
          role="status"
          class="tw-absolute tw-inset-x-0 tw-bottom-4 tw-mx-auto tw-w-max tw-rounded tw-bg-white tw-bg-opacity-90 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-gray-darken-2"
        ) {{ $t('Common.emptyStates.galleryTitle') }}
        div(class=" tw-z-10 tw-absolute tw-bottom-0 tw-right-0 tw-rounded-l-md  tw-pb-16  ")
          v-row(
            dense
            justify="end"
            class=" tw-py-2 tw-bg-lime-accent-3 tw-rounded-tl-md tw-shadow-md tw-rounded-bl-md tw-p-1 tw--mb-10"
          )
            v-col(v-if="property.rent_enabled" cols="auto")
              v-row(no-gutters justify="end")
                v-col(class=" tw-text-right")
                  span(class=" tw-text-base  tw-font-medium tw-text-purple-lighten-1 ") Rent
              v-row(no-gutters)
                v-col
                  span(class=" tw-text-purple-lighten-1 tw-text-lg tw-font-black ") {{ property.rent_price }} {{ property.rent_currency }} /mo
            v-divider(v-if="property.sale_enabled && property.rent_enabled" vertical class="tw-mx-1")
            v-col(v-if="property.sale_enabled" cols="auto")
              v-row(no-gutters justify="end")
                v-col(class=" tw-text-right")
                  span(class=" tw-text-base  tw-font-medium tw-text-purple-lighten-1 ") Sell
              v-row(no-gutters)
                v-col
                  span(class=" tw-text-purple-lighten-1 tw-text-lg tw-font-black ") {{ property.sale_price }} {{ property.sale_currency }}
</template>
<script>
export default {
  computed: {
    images() {
      return this.$store.getters['galleries/images'];
    },
    property() {
      return this.$store.getters['properties/property'];
    },
  },
};
</script>

<style scoped>
.v-carousel >>> .v-btn {
  margin: 0px;
}

.image-gallery-container {
  @media screen and (max-width: 767px) {
    max-width: 340px;
  }
}
</style>
